import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { onZefDialogClose, zefDialogClose, zefDialogOpen } from '@zerops/zef/dialog';
import { filter, map, mergeMap } from 'rxjs/operators';
import { l7ConfigDialogActions } from './l7-config-dialog.state';
import { FEATURE_NAME } from './l7-config-dialog.constant';
import { L7ConfigForm } from './l7-config-dialog.form';
import {
  loadL7HttpBalancerConfig,
  loadL7HttpBalancerConfigSuccess,
  updateL7HttpBalancerConfigSuccess
} from '@zerops/zerops/core/project-base';
import { transformResponseToL7FormData } from './l7-config.dialog.utils';

@Injectable()
export class L7ConfigDialogEffect {

  // # Deps
  #actions$ = inject(Actions);
  #form = inject(L7ConfigForm);

  // # Streams
  dialogClose$ = this.#actions$.pipe(onZefDialogClose(FEATURE_NAME));

  // # Effects
  onDialogOpen$ = createEffect(() => this.#actions$.pipe(
    ofType(l7ConfigDialogActions.open),
    map(({ projectId }) => zefDialogOpen({
      key: FEATURE_NAME,
      meta: { projectId }
    }))
  ));

  onDialogOpenLoadConfig$ = createEffect(() => this.#actions$.pipe(
    ofType(zefDialogOpen),
    filter(({ key }) => key === FEATURE_NAME),
    map(({ meta }) => loadL7HttpBalancerConfig({ projectId: meta.projectId }))
  ));

  onLoadConfigSuccess$ = createEffect(() => this.#actions$.pipe(
    ofType(loadL7HttpBalancerConfigSuccess),
    map(({ data }) => this.#form.setValue(
      transformResponseToL7FormData(data.response?.values)
    ))
  ));

  onUpdateConfigSuccess$ = createEffect(() => this.#actions$.pipe(
    ofType(updateL7HttpBalancerConfigSuccess),
    map(() => zefDialogClose({ key: FEATURE_NAME }))
  ));

  onDialogCloseResetForm$ = createEffect(() => this.dialogClose$.pipe(
    mergeMap(() => [
      this.#form.reset(),
      this.#form.setDefaultValues()
    ])
  ));
}
